import { render, staticRenderFns } from "./CotPropostaAccessoListComponent.vue?vue&type=template&id=9ef6a072"
import script from "./CotPropostaAccessoListComponent.vue?vue&type=script&lang=js"
export * from "./CotPropostaAccessoListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports